var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-7e7ba620": "",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-7e7ba620": "",
    d: "M3.04294 9.04284C2.79769 8.40992 3.65627 7.85567 4.2696 7.85567C4.88294 7.85567 6.72302 10.5268 6.72302 10.5268C6.72302 10.5268 11.3232 3.40384 11.6299 3.107C11.9365 2.81017 13.4699 3.107 12.8565 4.29417C12.3133 5.34567 7.33635 12.6043 7.33635 12.6043C7.33635 12.6043 6.72302 13.4946 6.10969 12.6043C5.49635 11.7139 3.28819 9.67575 3.04294 9.04284Z",
    className: "TransactionTable__button__ok-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.be29fdd945aa44d684c91544452f2ded.svg";
export { ForwardRef as ReactComponent };